import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../core/config.service';
import { Injectable } from '@angular/core';

@Injectable()
export class GatewayStatusService {
  constructor(private configService: ConfigService, private httpClient: HttpClient) {}

  getGateways(): any {
    const url = this.configService.getGatewayUrl() + '/gateway/list';
    return this.httpClient.get(url).toPromise();
  }

  getLocations() {
    const url = this.configService.getLocationServiceUrl() + '/location-service/list';
    return this.httpClient.get(url).toPromise();
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/gateway-status/gateway-status.service.ts